"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _withScopeId = function (n) { return ((0, vue_2.pushScopeId)("data-v-3a835ffe"), n = n(), (0, vue_2.popScopeId)(), n); };
var _hoisted_1 = { class: "back" };
var _hoisted_2 = { class: "poetry-detail-layout" };
var _hoisted_3 = { class: "card-header" };
var _hoisted_4 = { class: "poetry-content" };
var _hoisted_5 = { class: "other-data" };
var _hoisted_6 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return (0, vue_2.createElementVNode)("dt", { class: "line blue-circle" }, "译文", -1); });
var _hoisted_7 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return (0, vue_2.createElementVNode)("dt", { class: "line blue-circle" }, "注释", -1); });
var _hoisted_8 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return (0, vue_2.createElementVNode)("dt", { class: "line blue-circle" }, "赏析", -1); });
var vue_3 = require("vue");
var vue_router_1 = require("vue-router");
var element_plus_1 = require("element-plus");
var ancient_poetry_1 = require("@/apis/ancient-poetry");
exports.default = (0, vue_1.defineComponent)({
    __name: 'poetryDetail',
    setup: function (__props) {
        var _this = this;
        var router = (0, vue_router_1.useRouter)();
        var route = (0, vue_router_1.useRoute)();
        var ancientPoetryData = (0, vue_3.ref)({
            title: "",
            category: "",
            author: "",
            dynasty: "",
            content: [],
            translate: "",
            appreciation: "",
            notes: "",
            id: null
        });
        var userinfo = localStorage.getItem("user_data");
        var userData = userinfo && userinfo !== 'undefined' ? JSON.parse(userinfo) : {};
        var isCollected = (0, vue_3.ref)(false);
        var formData = {
            account: userData.user_account,
            data_type: "poetry",
            id: route.query.id,
            collected_status: false
        };
        var getCollectedInfo = function () { return __awaiter(_this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!userData.user_account) {
                            element_plus_1.ElMessage.warning("用户信息缺失，无法查询收藏信息");
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, ancient_poetry_1.ancientBooksApi.postCollected(formData)];
                    case 1:
                        res = _a.sent();
                        isCollected.value = res.data;
                        formData.collected_status = res.data;
                        return [2 /*return*/];
                }
            });
        }); };
        var setCollected = function () { return __awaiter(_this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ancient_poetry_1.ancientBooksApi.setCollected(formData)];
                    case 1:
                        res = _a.sent();
                        isCollected.value = res.data;
                        formData.collected_status = res.data;
                        element_plus_1.ElMessage.success(res.message);
                        return [2 /*return*/];
                }
            });
        }); };
        var getAncientPoetryDetail = function () { return __awaiter(_this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ancient_poetry_1.ancientPoetryApi.getAncientPoetryInfo(route.query.id)];
                    case 1:
                        data = (_a.sent()).data;
                        ancientPoetryData.value = data;
                        getCollectedInfo();
                        return [2 /*return*/];
                }
            });
        }); };
        getAncientPoetryDetail();
        var goBack = function () {
            if (route.query.limit) {
                router.push({ path: '/ancient/poetry', query: __assign({}, route.query) });
            }
            else {
                router.go(-1);
            }
        };
        return function (_ctx, _cache) {
            var _component_el_button = (0, vue_2.resolveComponent)("el-button");
            var _component_StarFilled = (0, vue_2.resolveComponent)("StarFilled");
            var _component_el_icon = (0, vue_2.resolveComponent)("el-icon");
            var _component_el_divider = (0, vue_2.resolveComponent)("el-divider");
            var _component_el_card = (0, vue_2.resolveComponent)("el-card");
            var _component_el_backtop = (0, vue_2.resolveComponent)("el-backtop");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", null, [
                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                    (0, vue_2.createVNode)(_component_el_button, {
                        class: "circleBtn",
                        type: "primary",
                        onClick: goBack,
                        plain: "",
                        icon: "ArrowLeft",
                        round: ""
                    }),
                    (0, vue_2.createElementVNode)("b", null, (0, vue_2.toDisplayString)(ancientPoetryData.value.title), 1),
                    (0, vue_2.createElementVNode)("span", {
                        class: "collected",
                        style: (0, vue_2.normalizeStyle)("color:".concat((0, vue_2.unref)(isCollected) ? 'orange' : 'gray')),
                        onClick: setCollected
                    }, [
                        (0, vue_2.createVNode)(_component_el_icon, null, {
                            default: (0, vue_2.withCtx)(function () { return [
                                (0, vue_2.createVNode)(_component_StarFilled)
                            ]; }),
                            _: 1
                        })
                    ], 4)
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createVNode)(_component_el_card, { class: "box-card" }, {
                        header: (0, vue_2.withCtx)(function () { return [
                            (0, vue_2.createElementVNode)("div", _hoisted_3, [
                                (0, vue_2.createElementVNode)("h3", null, (0, vue_2.toDisplayString)(ancientPoetryData.value.title), 1),
                                (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)(ancientPoetryData.value.author) + " · " + (0, vue_2.toDisplayString)(ancientPoetryData.value.dynasty) + " / " + (0, vue_2.toDisplayString)(ancientPoetryData.value.category), 1)
                            ])
                        ]; }),
                        default: (0, vue_2.withCtx)(function () { return [
                            (0, vue_2.createElementVNode)("div", _hoisted_4, [
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(ancientPoetryData.value.content, function (item, index) {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("p", { key: index }, (0, vue_2.toDisplayString)(item), 1));
                                }), 128)),
                                (0, vue_2.createVNode)(_component_el_divider)
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_5, [
                                (0, vue_2.createElementVNode)("dl", null, [
                                    _hoisted_6,
                                    (0, vue_2.createElementVNode)("dd", null, (0, vue_2.toDisplayString)(ancientPoetryData.value.translate), 1)
                                ]),
                                (0, vue_2.createElementVNode)("dl", null, [
                                    _hoisted_7,
                                    (0, vue_2.createElementVNode)("dd", null, (0, vue_2.toDisplayString)(ancientPoetryData.value.notes), 1)
                                ]),
                                (0, vue_2.createElementVNode)("dl", null, [
                                    _hoisted_8,
                                    (0, vue_2.createElementVNode)("dd", null, (0, vue_2.toDisplayString)(ancientPoetryData.value.appreciation), 1)
                                ])
                            ])
                        ]; }),
                        _: 1
                    })
                ]),
                (0, vue_2.createVNode)(_component_el_backtop)
            ]));
        };
    }
});
